import { render, staticRenderFns } from "./ListAntrianMobile.vue?vue&type=template&id=876f6c4a&"
import script from "./ListAntrianMobile.vue?vue&type=script&lang=js&"
export * from "./ListAntrianMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports